/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M2.25 2.6154c-.4142 0-.75.3616-.75.8077v4.8461c0 .4461.3358.8077.75.8077H9c.4142 0 .75-.3616.75-.8077V3.4231c0-.4461-.3358-.8077-.75-.8077H2.25ZM0 3.423C0 2.0849 1.0074 1 2.25 1H9c1.2426 0 2.25 1.0848 2.25 2.423v4.8462c0 1.3383-1.0074 2.4231-2.25 2.4231H2.25c-1.2426 0-2.25-1.0848-2.25-2.423V3.423Zm2.25 10.5c-.4142 0-.75.3616-.75.8077v4.8461c0 .4461.3358.8077.75.8077H9c.4142 0 .75-.3616.75-.8077v-4.8461c0-.4461-.3358-.8077-.75-.8077H2.25ZM0 14.7308c0-1.3383 1.0074-2.4231 2.25-2.4231H9c1.2426 0 2.25 1.0848 2.25 2.4231v4.8461C11.25 20.9151 10.2426 22 9 22H2.25C1.0074 22 0 20.9151 0 19.5769v-4.8461ZM22.5 3.4231c0-.4461-.3358-.8077-.75-.8077H15c-.4142 0-.75.3616-.75.8077v4.8461c0 .4461.3358.8077.75.8077h6.75c.4142 0 .75-.3616.75-.8077V3.4231Zm-9.75 0C12.75 2.0849 13.7574 1 15 1h6.75C22.9926 1 24 2.0848 24 3.423v4.8462c0 1.3383-1.0074 2.4231-2.25 2.4231H15c-1.2426 0-2.25-1.0848-2.25-2.423V3.423Zm2.25 10.5c-.4142 0-.75.3616-.75.8077v4.8461c0 .4461.3358.8077.75.8077h6.75c.4142 0 .75-.3616.75-.8077v-4.8461c0-.4461-.3358-.8077-.75-.8077H15Zm-2.25.8077c0-1.3383 1.0074-2.4231 2.25-2.4231h6.75c1.2426 0 2.25 1.0848 2.25 2.4231v4.8461C24 20.9152 22.9926 22 21.75 22H15c-1.2426 0-2.25-1.0848-2.25-2.4231v-4.8461Z"
    clipRule="evenodd"
  />,
  'Tiles'
);
